import { useCallback, useState } from "react";
import { useDispatch } from "react-redux";
import { setIsdCode, setMobileNumber } from "@store/login/loginStore";
import type { PhoneCredentials } from "./types";

const PHONE_STORAGE_KEY = "phoneData";

export function readStoredPhoneCredentials(): PhoneCredentials | null {
  const raw = localStorage.getItem(PHONE_STORAGE_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw) as PhoneCredentials;
  } catch {
    return null;
  }
}

export function usePhoneCredentials(initialDialCode = "+91") {
  const dispatch = useDispatch();
  const [phoneNumber, setPhoneNumber] = useState("");
  const [countryCode, setCountryCode] = useState(initialDialCode);

  const persistPhone = useCallback(
    (dialCode: string, number: string) => {
      dispatch(setIsdCode(dialCode));
      dispatch(setMobileNumber(number));
      localStorage.setItem("phoneNumber", number);
      localStorage.setItem("countryCode", dialCode);
      localStorage.setItem(
        PHONE_STORAGE_KEY,
        JSON.stringify({ dialCode, number })
      );
    },
    [dispatch]
  );

  const updatePhoneNumber = (value: string) => {
    const digits = value.replace(/\D/g, "");
    setPhoneNumber(digits);
    persistPhone(countryCode, digits);
  };

  const updateCountryCode = (dialCode: string) => {
    setCountryCode(dialCode);
    persistPhone(dialCode, phoneNumber);
  };

  const getPhoneData = (): PhoneCredentials => ({
    dialCode: countryCode,
    number: phoneNumber,
  });

  const isPhoneComplete = phoneNumber.length === 10;

  return {
    phoneNumber,
    countryCode,
    isPhoneComplete,
    updatePhoneNumber,
    updateCountryCode,
    getPhoneData,
    persistPhone,
  };
}
